var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.$style.main,attrs:{"active-class":_vm.$style.underline,"tag":"span","to":_vm.p_item.to}},[_vm._v(_vm._s(_vm.p_item.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }